import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "model"
};
const _hoisted_2 = {
  class: "model-body"
};
const _hoisted_3 = {
  class: "model-footer"
};
import { gsap } from "gsap";
export default {
  __name: 'model',
  props: ["show", "onCancel", "cLabel", "onSucsuss", "sLabel"],
  setup(__props) {
    let enter = () => {
      gsap.to(".model-overlay", {
        opacity: 1,
        duration: 0.5
      });
      gsap.to(".model", {
        opacity: 1,
        duration: 0.3,
        scale: 1,
        delay: 0.5
      });
      document.body.style.overflow = "hidden";
    };
    let leave = () => {
      gsap.to(".model", {
        opacity: 0,
        duration: 1,
        scale: 0
      });
      gsap.to(".model-overlay", {
        opacity: 0,
        duration: 0.5,
        delay: 0.5
      });
      document.body.style.overflow = "auto";
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, {
        onEnter: _unref(enter),
        onLeave: _unref(leave),
        appear: "",
        name: "model"
      }, {
        default: _withCtx(() => [__props.show ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "model-overlay",
          onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => __props.onCancel && __props.onCancel(...args), ["self"]))
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "body")]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "footer", {}, () => [__props.cLabel ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-primary btn-reset-outline",
          onClick: _cache[0] || (_cache[0] = (...args) => __props.onCancel && __props.onCancel(...args))
        }, _toDisplayString(__props.cLabel), 1)) : _createCommentVNode("", true), __props.sLabel ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn-primary border-0 shadow-none",
          onClick: _cache[1] || (_cache[1] = (...args) => __props.onSucsuss && __props.onSucsuss(...args))
        }, _toDisplayString(__props.sLabel), 1)) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["onEnter", "onLeave"]);
    };
  }
};